import { themr } from '@friendsofreactjs/react-css-themr';
import { compose } from 'recompose';
import intlEquipped from '../../../hocs/intlEquipped';

import CancelSubscriptionConfirmationModal from './CancelSubscriptionConfirmationModal';

const enhance = compose(
    themr('CancelSubscriptionConfirmationModal'),
    intlEquipped
);

export default enhance(CancelSubscriptionConfirmationModal);
